import ResourceLanding from './component'

export default ResourceLanding
